'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var sanitizeHtml = require('sanitize-html');
var mustache = require('mustache');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var Paragraph = require('@narvar/nth-bit-paragraph');
var nthBitHeader = require('@narvar/nth-bit-header');
var ProductThumbnail = require('@narvar/nth-block-product-thumbnail');
var ItemTile_module = require('./ItemTile.module.css.js');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var sanitizeHtml__default = /*#__PURE__*/_interopDefaultLegacy(sanitizeHtml);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var ProductThumbnail__default = /*#__PURE__*/_interopDefaultLegacy(ProductThumbnail);

const renderOptions = {
  escape: x => x
};
// do not allow html tags in item attribute text
const safetyHtml = text => sanitizeHtml__default["default"](text, {
  allowedTags: []
});
const ItemTile = ({
  itemInfo,
  itemTextTemplates,
  featureName
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    loading,
    settings
  } = nthHookSettings.useSettingsX();
  const {
    imageUrl: imageUrlTemplate = '',
    url: itemUrlTemplate = ''
  } = settings.itemsInThisShipment ?? {};

  // Currently the "hack" to not show the product images is setting the
  // image template setting to ' '. In an upcoming refresh of the items
  // in this shipment component settings, there will be a boolean flag
  // we'll be able to check instead of looking for ' '.
  const hideProductImage = imageUrlTemplate === ' ';
  const {
    price
  } = itemInfo;
  const tempPrice = price;
  let itemInfoPriceFormatted = itemInfo;
  // check if price contains any possible currency signs, and if not,
  // display in two-decimal format. otherwise, leave it as is.
  const alreadyFormatted = tempPrice && tempPrice.replaceAll(/[.,]/g, '').match(/[\D]/);
  if (price && !alreadyFormatted) {
    const priceNumber = parseFloat(price);

    // TODO: make this configurable and switch to 'currenty' options
    const priceFormatter = Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const formattedPrice = priceFormatter.format(priceNumber);
    itemInfoPriceFormatted = {
      ...itemInfo,
      price: formattedPrice
    };
  }
  const itemTitle = itemTextTemplates.itemsInShipmentItemTitle && typeof itemTextTemplates.itemsInShipmentItemTitle === 'string' ? mustache__default["default"].render(itemTextTemplates.itemsInShipmentItemTitle, itemInfoPriceFormatted, undefined, renderOptions) : '';
  let thumbnail;
  if (!(loading || hideProductImage)) {
    thumbnail = /*#__PURE__*/React__default["default"].createElement(ProductThumbnail__default["default"], {
      productInfo: itemInfoPriceFormatted,
      urlTemplate: itemUrlTemplate || undefined,
      imageUrlTemplate: imageUrlTemplate || undefined,
      renderAsLink: false
    });
  }
  const hasImage = Boolean(thumbnail);
  const textContainerClasses = clsx.clsx(!hasImage && ItemTile_module["default"].textContainer, hasImage && ItemTile_module["default"].textContainerWithImage);
  const itemBlock = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, thumbnail, /*#__PURE__*/React__default["default"].createElement("div", {
    className: textContainerClasses
  }, itemTitle && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "p",
    featureName: featureName
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: safetyHtml(itemTitle)
    }
  })), [itemTextTemplates.itemsInShipmentAttribute0, itemTextTemplates.itemsInShipmentAttribute1, itemTextTemplates.itemsInShipmentAttribute2, itemTextTemplates.itemsInShipmentAttribute3].map(template => {
    if (!template || typeof template !== 'string') return null;
    const renderedText = mustache__default["default"].render(template, itemInfoPriceFormatted, undefined, renderOptions);
    return /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
      featureName: featureName,
      key: renderedText,
      containerCustomStyle: {
        margin: '0.25rem 0',
        overflowWrap: 'break-word'
      }
    }, safetyHtml(renderedText));
  })));
  const itemUrl = mustache__default["default"].render(itemUrlTemplate || '', itemInfoPriceFormatted, undefined, renderOptions);
  const componentEventLog = {
    ['shipments']: {
      clickComponent: nthHookContextAnalytics.NarvarClickSubTypes.SHIPMENTS,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_SHIPMENTS
    },
    ['itemsInThisShipment']: {
      clickComponent: nthHookContextAnalytics.NarvarClickSubTypes.ITEMS_IN_THIS_SHIPMENT,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_ITEMS_IN_THIS_SHIPMENT
    }
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ItemTile_module["default"].container
  }, itemUrl ? /*#__PURE__*/React__default["default"].createElement("a", {
    href: itemUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: () => logEvent({
      clickLinkDestinationUrl: itemUrl,
      clickLinkLabel: itemUrl,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      ...(featureName === 'shipments' || featureName === 'itemsInThisShipment' ? {
        clickCategory: componentEventLog[featureName].clickComponent,
        clickSubType: componentEventLog[featureName].clickComponent,
        eventComponent: componentEventLog[featureName].eventComponent,
        eventFeature: componentEventLog[featureName].eventComponent,
        pageComponent: componentEventLog[featureName].eventComponent
      } : {})
    })
  }, itemBlock) : itemBlock);
};
var ItemTile$1 = nthHookSettings.withSettingsProvider(ItemTile, {
  settingsRequested: `
    itemsInThisShipment {
      imageUrl
      url
    }
  `
});

exports["default"] = ItemTile$1;
